<template>
  <div>
    <v-container class="page-title page-title--advanced">
      <v-row>
        <v-col class="page-title__title-box">
          <h4 class="page-title__title">{{ $t('heading.instance.advanced.reporting.title') }}</h4>
        </v-col>
      </v-row>
    </v-container>
    <v-container>
      <v-row>
        <v-col cols="12" class="pb-2">
          <v-card elevation="4">
            <v-card-text class="d-flex justify-space-between text--gray-darken2">
              <div>
                <h5>{{ $t('heading.instance.advanced.reporting.tag.title') }}</h5>
                <p class="mb-0 mt-1 pr-8">
                  {{ $t('heading.instance.advanced.reporting.tag.subtitle') }}
                </p>
                <p
                  v-if="instance.report_provider_tag_disabled"
                  class="mb-0 mt-2 warning--text"
                >
                  {{ $t('heading.instance.advanced.reporting.tag.disabledNote') }}
                </p>
              </div>
              <div class="d-flex align-center">
                <ButtonSwitch
                  :loading="submittingTag"
                  :value="!instance.report_provider_tag_disabled"
                  @click.native.stop.prevent="toggleTag"
                />
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import Api from "@/apis/Api";
import ButtonSwitch from "../../../components/buttons/ButtonSwitch.vue";

export default {
  components: {
    ButtonSwitch,
  },
  props: {
    instance: Object,
  },
  data() {
    return {
      submittingTag: false,
    };
  },
  methods: {
    async toggleTag() {
      this.submittingTag = true;

      const disabled = !this.instance.report_provider_tag_disabled;

      try {
        await this.instance.updateReportProviderTag(disabled);
        this.instance.setReportProviderTagDisabled(disabled);
        this.$store.dispatch("addAlert", {
          success: true,
          successMessage: this.$t('notification.instance.settings.update')
        });
      } catch (error) {
        this.$store.dispatch("addAlert", {
          success: false,
          errorMessage: Api.getErrorMessage(error),
        });
      } finally {
        this.submittingTag = false;
      }
    },
  },
};
</script>